import { BsGrid3X2 } from "react-icons/bs";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Pages Mosaic",
  name: "pageMosaic",
  type: "object",
  icon: BsGrid3X2,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "heading",
      title: "Heading",
      type: "sectionTitle"
    },
    {
      name: "items",
      title: "Pages",
      type: "array",
      of: [
        {
          type: "reference",
          to: { type: "page" }
        }
      ]
    },
    {
      name: "mosaicVariant",
      description: "Layout variant for the mosaic",
      type: "string",
      validation: (Rule) => Rule.required(),
      options: {
        list: [
          { title: "3 Columns", value: "column3" },
          { title: "2 (first row) + 3 Columns", value: "column2+3" },
          { title: "2 Columns", value: "column2" }
        ]
      }
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      items: "items"
    },
    prepare({ title, items }) {
      return {
        title: multilingualStringPreview(title) || "([Pages] Mosaic)",
        subtitle: `${items.length} pages`
      };
    }
  }
});
